import React from "react";
import {BrowserRouter as Router, Route, Routes, useLocation} from "react-router-dom";


import Dashboard from "./components/projector/dashboard";


import Story from "./components/thumbs/story.js";

import Sket from "./components/sket.js";
import SujetP from "./components/thumbs/sujetP.js";

import CanvL from "./components/canvL.js";
import {DomProvider} from "./context/dom.js";
import Farm from "./components/farm.js";
import ProfilePage from "./components/pro";
import MyForm from "./components/users/form";
import {Login} from "./components/users/login";

import Esketchos from "./components/esketchos";
import Stripe from "./components/users/stripe";
import FarmAI from "./components/farmAI";
import Main from "./components/CV/main";
import About from "./components/CV/about";
import Cv from "./components/CV/cv";
import Contacts from "./components/CV/contacts";
import Nav from "./components/nav";
import {LangProvider} from "./context/lang";
import Escalera from "./components/CV/escalera";
import Pose from "./pose/pose";
import Test from "./components/projector/test";
import CameraSegmenterPaperJS from "./pose/multi";
import All from "./pose/all";


export const tenant = "6nz5z4rb";
/*


export default withRouter(function App({ location }) {
  const [currentPath, setCurrentPath] = useState(location.pathname);

  useEffect(() => {
    const { pathname } = location;
    console.log("New path:", pathname);
    setCurrentPath(pathname);
  }, [location.pathname]);
 */
export default function App() {

const href= window.location.href;

  //''


//console.log(href);
  return (
<>
  {href.match(/tca/) ? (
    <Router>

          <Routes>
            <Route path="/" element={<Cv/>}/>


          </Routes>
    </Router>



  )  : href.match(/potol/) ? (
    <div className="bg-gray-100  d-flex flex-col justify-between" style={{height: "100vh"}}>


      <Router>
        <LangProvider>
          { !href.match(/escalera/) &&  <Nav/>}
          <div className="lg:container lg:mx-auto md:container md:mx-auto sm:p-4">
          <Routes>
            <Route path="/" element={<Main/>}/>
            <Route path="about" element={<About/>}/>
            <Route path="cv" element={<Cv/>}/>
            <Route path="contacts" element={<Contacts/>}/>
            <Route path="escalera" element={<Escalera/>}/>
          </Routes>
        </div>
        </LangProvider>
      </Router>
      <div className="text-center text-neutral-400 mt-8"> <small>copyright 2026, Aleksandr Potolitsyn</small></div>
    </div>
  ) : (
    <Router>

      <div className="checker_" style={{position: 'relative', justifyContent: 'center'}} id="ttid">
      <div style={{position: 'absolute', top: 0}}></div>
            <DomProvider>
              <Routes>
                <Route path="/" element= {<ProfilePage/> }/>
             <Route path="story/:id" element={<Story/>}>

                  <Route path=":mname" element={<Sket/>}/>
                </Route>
                <Route path="pose" element={<Pose/>}/>
                <Route path="cam" element={<CameraSegmenterPaperJS/>}/>
                <Route path="cam1" element={<All/>}/>
                <Route path="ts" element={<Test/>}/>
                <Route path="farm" element={<Farm /> }/>
                <Route path="ai" element={<FarmAI /> }/>
                <Route path="CV" element={<Main/> }/>
                <Route path="gallery" element={<Esketchos/>}/>
              <Route path="draw" element={<CanvL/>}>
                <Route path=":location" element={<CanvL/>}/>
              </Route>

                <Route path="form" element={<MyForm/>}/>
              <Route path="sujet/:idS" element={<SujetP/>}/>
              <Route path="sujetP/:id" element={<Sket/>}/>
                <Route path="login" element={<Login/>}/>
                <Route path="register" element={<ProfilePage/>}/>
              <Route
                path="/dashboard"
                element={

                    <Dashboard/>

                }
              />

                <Route path="stories" element={<Story/>}/>

                <Route path=":sstory" element={<Story/>}>
                  <Route path=":sujetId" element={<Story/>}/>
                </Route>
                <Route path="stripe" element={<Stripe/>}/>
            </Routes>
            </DomProvider>
          </div>


    </Router>

  )
}
</>

  );
}


function RequireAuth({children}) {
  let location = useLocation();


  return children;
}
